function o(){return{FORC:"0.35.5",FUEL_CORE:"0.17.3",FUELS:"0.42.0"}}var p=o();export{p as versions};
//# sourceMappingURL=index.mjs.map